/**
 * Cookie consent management utility
 * Manages cookie consent state in localStorage with default enabled (opt-out model)
 */

const STORAGE_KEY = 'gantty_cookie_consent';

/**
 * Get current cookie consent status
 * @returns true if cookies are enabled, false if disabled
 */
export function getCookieConsent(): boolean {
  if (typeof window === 'undefined') {
    return true; // Default to enabled on server-side
  }

  const stored = localStorage.getItem(STORAGE_KEY);
  
  // If no value stored, default to enabled (opt-out model)
  if (stored === null) {
    return true;
  }

  // Parse stored value
  try {
    return stored === 'true';
  } catch {
    // If parsing fails, default to enabled
    return true;
  }
}

/**
 * Set cookie consent status
 * @param enabled - true to enable cookies, false to disable
 */
export function setCookieConsent(enabled: boolean): void {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.setItem(STORAGE_KEY, String(enabled));
}

/**
 * Check if user has explicitly consented (has made a choice)
 * @returns true if user has made a choice, false if using default
 */
export function hasUserConsented(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }

  return localStorage.getItem(STORAGE_KEY) !== null;
}



